import { useCallback, useState } from "react";

import useMutationWithValidation from "@hooks/useMutationWithValidation";
import {
  AppEventActionKindEnum,
  AppEventCreateDocument,
  AppEventCreateMutation,
  AppEventCreateMutationVariables
} from "@typing/Generated";

const useRegisterPlayedVideo = (articleId: string, journeyId: string | null) => {
  const [played, setPlayed] = useState(false);

  const [createAppEvent] = useMutationWithValidation<AppEventCreateMutation, AppEventCreateMutationVariables>(
    AppEventCreateDocument,
    "appEvent"
  );

  const videoPlayedAppEventCreate = useCallback(() => {
    createAppEvent({
      actionKind: AppEventActionKindEnum.ARTICLE_VIDEO_PLAYED,
      journeyId,
      resourceId: articleId
    });
  }, [articleId, createAppEvent, journeyId]);

  const onVideoPlay = useCallback(() => {
    if (!played && videoPlayedAppEventCreate) {
      videoPlayedAppEventCreate();
      setPlayed(true);
    }
  }, [played, videoPlayedAppEventCreate]);

  return onVideoPlay;
};

export default useRegisterPlayedVideo;
